import {Injectable} from '@angular/core';
import {CommonService} from './common.service';
import {Pagination, StatusCode} from '../constants';
import {Observable} from 'rxjs';
import {ResponseResult} from '../interfaces';

@Injectable({
    providedIn: 'root',
})
export class CategoryService {
    constructor(private commonService: CommonService) {
    }

    CateGetAll(
        pageIndex: number = Pagination.PageIndex,
        pageSize: number = Pagination.PageSize
    ): Observable<ResponseResult> {
        return this.commonService.getAll(
            `product-category`,
            false,
            pageSize,
            pageIndex
        );
    }

    getListProductForSalerBought(model): Observable<ResponseResult> {
        return this.commonService.getDataByBody(
            `order/history-by-body`,
            model
        );
    }

    getMaterials(model): Observable<ResponseResult> {
        return this.commonService.getDataByBody(
            `product-category/product-material-for-web`,
            model
        );
    }


    ExportProductForSalerBought(model): Observable<ResponseResult> {
        return this.commonService.createData(`export/materials`, model);
    }

    CateGetById(id): Observable<ResponseResult> {
        return this.commonService.getById(`product-category/${id}/detail`);
    }

    CateCreate(model): Observable<ResponseResult> {
        return this.commonService.createData(`product-category`, model);
    }

    CateUpdate(model): Observable<ResponseResult> {
        return this.commonService.updateData(`product-category/${model.id}`, model);
    }

    CateDelete(id): Observable<ResponseResult> {
        return this.commonService.deleteData(`product-category/${id}`);
    }

    RegisterGetAll(
        cateId: number,
        status: string,
        fromDate: any = null,
        toDate: any = null,
        wardId: number = null,
        districtId: number = null,
        provinceId: number = null,
        pageIndex: number = Pagination.PageIndex,
        pageSize: number = Pagination.PageSize
    ): Observable<ResponseResult> {
        let url = `product-category/${cateId}/register?status=${status}`;
        if (fromDate) {
            url = url + `&fromDate=${fromDate}&toDate=${toDate}`;
        }
        if (wardId) {
            url = url + `&wardId=${wardId}`;
        }
        if (districtId) {
            url = url + `&districtId=${districtId}`;
        }
        if (provinceId) {
            url = url + `&provinceId=${provinceId}`;
        }
        return this.commonService.getAll(url, true, pageSize, pageIndex);
    }

    registerGetAllByFilter(
        model: any,
        pageIndex: number = Pagination.PageIndex,
        pageSize: number = Pagination.PageSize
    ): Observable<ResponseResult> {
        const url = `product-category/register-filter-by-list?pageSize=${pageSize}&pageIndex=${pageIndex}`;
        return this.commonService.getDataByBody(url, model);
    }

    RegisterRating(
        cateId: number,
        fromDate: any = null,
        toDate: any = null,
        wardId: number = null,
        districtId: number = null,
        provinceId: number = null,
        filter: any = null,
        pageIndex: number = Pagination.PageIndex,
        pageSize: number = Pagination.PageSize
    ): Observable<ResponseResult> {
        let url = `product-category/register-rating?id=${cateId}`;
        if (fromDate) {
            url = url + `&fromDate=${fromDate}&toDate=${toDate}`;
        }
        if (wardId) {
            url = url + `&wardId=${wardId}`;
        }
        if (districtId) {
            url = url + `&districtId=${districtId}`;
        }
        if (provinceId) {
            url = url + `&provinceId=${provinceId}`;
        }
        return this.commonService.getAll(url, true, pageSize, pageIndex);
    }

    RegisterGetById(id): Observable<ResponseResult> {
        return this.commonService.getById(`product-category/register/${id}/detail`);
    }

    RegisterCreate(model): Observable<ResponseResult> {
        return this.commonService.createData(`product-category/register`, model);
    }

    SaveRating(model): Observable<ResponseResult> {
        return this.commonService.createData(`product-category/register-rating`, model);
    }

    SaveScale(model): Observable<ResponseResult> {
        return this.commonService.createData(`product-category/update-register-rating-scale`, model);
    }

    RegisterUpdate(model): Observable<ResponseResult> {
        return this.commonService.updateData(
            `product-category/register/${model.id}`,
            model
        );
    }

    UpdateBagsCount(model): Observable<ResponseResult> {
        return this.commonService.updateData(
            `product-category/update-bags-count`,
            model
        );
    }

    RegisterDelete(id): Observable<ResponseResult> {
        return this.commonService.deleteData(`product-category/register/${id}`);
    }

    StatusCreate(model): Observable<ResponseResult> {
        return this.commonService.createData(`product-category/status`, model);
    }

    GetBatchCode(userId): Observable<ResponseResult> {
        return this.commonService.getById(
            `product-category/batch-code-generate/${userId}`
        );
    }

    RegisterRatingByFilter(model): Observable<ResponseResult> {
        return this.commonService.getDataByBody(
            `product-category/register-rating-filter-by-list`,
            model,
            '',
            '0');
    }

    RegisterRatingScaleByFilter(model): Observable<ResponseResult> {
        return this.commonService.getDataByBody(
            `product-category/register-rating-scale`,
            model,
            '',
            '0');
    }

    RecutCreate(model): Observable<ResponseResult> {
        return this.commonService.createData(`product-category/recut`, model);
    }
}
